module.exports = __webpack_public_path__ + "static/assets/983df5c5f7c9e82a69a5904e5a03d68d.png";